export default __webpack_public_path__ + "fonts/Aeonik-Medium_c5824e8869e77f64b83d8c0719fa7066.woff2";